import type { BiMetricConfig } from '@repo/api-codegen';

// TODO(nhanthai): Move this to ChartConfigHelper
export const getAxesSettings = (config: BiMetricConfig['chart_config']) => {
	if (
		config.chartType === 'bar' ||
		config.chartType === 'line' ||
		config.chartType === 'scatter' ||
		config.chartType === 'pie'
	) {
		if ('axes' in config) {
			return config.axes as {
				x: string[];
				y: string[];
				category?: string[];
				size?: string[];
			};
		}
	}

	return {
		x: [],
		y: [],
		category: [],
		size: [],
	};
};
